import type { AxiosInstance } from "axios";

import { getSystemTransferListOperations } from "./paths/transfer-list/operations.ts";
import { getResourceOperations } from "./paths/resource/operations.ts";
import { getGlobalSettingsOperations } from "./paths/global-settings/operations.ts";
import { getSystemProductTransferListOperations } from "./paths/product-transfer-list/operations.ts";

export const getSystemOperations = (client: AxiosInstance) => {
  return {
    transferList: getSystemTransferListOperations(client),
    productTransferList: getSystemProductTransferListOperations(client),
    resource: getResourceOperations(client),
    globalSettings: getGlobalSettingsOperations(client),
  };
};
